// extracted by mini-css-extract-plugin
export var grid = "Home-module--grid--7JeVX";
export var text = "Home-module--text--2i9gz";
export var numColor = "Home-module--numColor--15R-f";
export var br = "Home-module--br--2vwKn";